import React from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  Box,
  Divider,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Input,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Text,
} from "@chakra-ui/react";
import Header from "../components/Header";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { getAllCricketMatchListAPI } from "../service/cricket";
import { getAllMatchListAPI } from "../service/AuthService";

const PrivateOutlet = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const location = useLocation();
  const [cricketMatchList, setCricketMatchList] = React.useState({});
  const [soccerMatchList, setSoccerMatchList] = React.useState({});
  const [tennisMatchList, setTennisMatchList] = React.useState({});
  const btnRef = React.useRef();
  const getAllMatchList = async () => {
    const { response } = await getAllMatchListAPI();
    setCricketMatchList(response?.cricket);
    setSoccerMatchList(response?.soccer);
    setTennisMatchList(response?.tennis);
  };
  const userData = useSelector((state) => state.account.userData);
  useEffect(() => {
    getAllMatchList();
  }, []);
  if (!userData.token) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <Box minH="100vh">
        <Header onOpen={onOpen} drawerButtonRef={btnRef} />

        {/* Desktop Left Sidebar */}
        <Box className="desktop-left-sidebar">
          <Box className="sidebar-logo-area">
            <a href="/admin">
              <img
                src={require("../assets/img/logo-white.png")}
                alt="Indoexch"
                className="sidebar-logo-img"
              />
            </a>
            <div
              ref={btnRef}
              className="sidebar-hamburger"
              onClick={onOpen}
            >
              <div className="bar1"></div>
              <div className="bar2"></div>
              <div className="bar3"></div>
            </div>
          </Box>
          <nav>
            <Link to="/admin">
              <Box className={`sidebar-link ${location.pathname === '/admin' ? 'active' : ''}`}>
                <i className="fas fa-home" />
                <span>Dashboard</span>
              </Box>
            </Link>
            <Link to="/admin/manage-client/list">
              <Box className={`sidebar-link ${location.pathname === '/admin/manage-client/list' && !location.search ? 'active' : ''}`}>
                <i className="fas fa-users" />
                <span>List of Clients</span>
              </Box>
            </Link>
            <Accordion allowMultiple allowToggle>
              <AccordionItem border="none">
                <AccordionButton className="sidebar-accordion-btn">
                  <Box as="span" flex="1" textAlign="left">
                    <i className="fas fa-chess-queen" />
                    <span>Admin Masters</span>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel p={0} className="sidebar-accordion-panel">
                  <Link to="/admin/manage-client/list?filter=MASTER">
                    <Box className="sidebar-sublink">All Masters</Box>
                  </Link>
                  <Link to="/admin/manage-client/list?filter=CLIENT">
                    <Box className="sidebar-sublink">All Clients</Box>
                  </Link>
                  <Link to="/admin/manage-client/add">
                    <Box className="sidebar-sublink">Register New Client</Box>
                  </Link>
                </AccordionPanel>
              </AccordionItem>

              {/* <AccordionItem border="none">
                <AccordionButton className="sidebar-accordion-btn">
                  <Box as="span" flex="1" textAlign="left">
                    <i className="fas fa-credit-card" />
                    <span>Payment Solution</span>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel p={0} className="sidebar-accordion-panel">
                  <Link to="/admin/bank-details">
                    <Box className="sidebar-sublink">Bank Details</Box>
                  </Link>
                  <Link to="/admin/payment-snap">
                    <Box className="sidebar-sublink">Payment Snap</Box>
                  </Link>
                  <Link to="/admin/withdrawal-requests">
                    <Box className="sidebar-sublink">Withdrawal Requests</Box>
                  </Link>
                </AccordionPanel>
              </AccordionItem> */}

              <AccordionItem border="none">
                <AccordionButton className="sidebar-accordion-btn">
                  <Box as="span" flex="1" textAlign="left">
                    <i className="fas fa-file-alt" />
                    <span>Reports</span>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel p={0} className="sidebar-accordion-panel">
                  <Link to="/admin/reports/current-bet"><Box className="sidebar-sublink">Current Bets</Box></Link>
                  <Link to="/admin/reports/account-statement"><Box className="sidebar-sublink">Account Statement</Box></Link>
                  <Link to="/admin/reports/bet-history"><Box className="sidebar-sublink">Bet History</Box></Link>
                  <Link to="/admin/reports/profit-loss"><Box className="sidebar-sublink">User PnL</Box></Link>
                  <Link to="/admin/reports/casino-report"><Box className="sidebar-sublink">Casino Report</Box></Link>
                  <Link to="/admin/market-analysis"><Box className="sidebar-sublink">Market Analysis</Box></Link>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>

            <Link to="/admin/whatsapp-links">
              <Box className={`sidebar-link ${location.pathname === '/admin/whatsapp-links' ? 'active' : ''}`}>
                <i className="fab fa-whatsapp" style={{ color: 'inherit' }} />
                <span>WhatsApp Links</span>
              </Box>
            </Link>

            <Divider borderColor="rgba(255,255,255,0.1)" my={2} />

            <Box px={4} py={1}>
              <span className="sidebar-section-label">Sports</span>
            </Box>
            <Accordion allowMultiple allowToggle>
              <AccordionItem border="none">
                <AccordionButton className="sidebar-accordion-btn">
                  <Box as="span" flex="1" textAlign="left">
                    <i className="fas fa-futbol" />
                    <span>Football</span>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel p={0} className="sidebar-accordion-panel">
                  {soccerMatchList &&
                    Object.keys(soccerMatchList).map((league) => (
                      <Accordion allowToggle allowMultiple key={league}>
                        <AccordionItem border="none">
                          <AccordionButton className="sidebar-accordion-btn" py={1} pl={10}>
                            <Box as="span" flex="1" textAlign="left" fontSize="13px">
                              {league}
                            </Box>
                            <AccordionIcon />
                          </AccordionButton>
                          <AccordionPanel p={0}>
                            {soccerMatchList[league].map((match) => (
                              <Link to={`/admin/game/soccer/${match.id}`} key={match.id}>
                                <Box className="sidebar-sublink" pl="56px" fontSize="12px">{match.eventName}</Box>
                              </Link>
                            ))}
                          </AccordionPanel>
                        </AccordionItem>
                      </Accordion>
                    ))}
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem border="none">
                <AccordionButton className="sidebar-accordion-btn">
                  <Box as="span" flex="1" textAlign="left">
                    <i className="fas fa-baseball-ball" />
                    <span>Cricket</span>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel p={0} className="sidebar-accordion-panel">
                  {cricketMatchList &&
                    Object.keys(cricketMatchList).map((league) => (
                      <Accordion allowToggle allowMultiple key={league}>
                        <AccordionItem border="none">
                          <AccordionButton className="sidebar-accordion-btn" py={1} pl={10}>
                            <Box as="span" flex="1" textAlign="left" fontSize="13px">
                              {league}
                            </Box>
                            <AccordionIcon />
                          </AccordionButton>
                          <AccordionPanel p={0}>
                            {cricketMatchList[league].map((match) => (
                              <Link to={`/admin/game/cricket/${match.id}`} key={match.id}>
                                <Box className="sidebar-sublink" pl="56px" fontSize="12px">{match.eventName}</Box>
                              </Link>
                            ))}
                          </AccordionPanel>
                        </AccordionItem>
                      </Accordion>
                    ))}
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem border="none">
                <AccordionButton className="sidebar-accordion-btn">
                  <Box as="span" flex="1" textAlign="left">
                    <i className="fas fa-table-tennis" />
                    <span>Tennis</span>
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel p={0} className="sidebar-accordion-panel">
                  {tennisMatchList &&
                    Object.keys(tennisMatchList).map((league) => (
                      <Accordion allowToggle allowMultiple key={league}>
                        <AccordionItem border="none">
                          <AccordionButton className="sidebar-accordion-btn" py={1} pl={10}>
                            <Box as="span" flex="1" textAlign="left" fontSize="13px">
                              {league}
                            </Box>
                            <AccordionIcon />
                          </AccordionButton>
                          <AccordionPanel p={0}>
                            {tennisMatchList[league].map((match) => (
                              <Link to={`/admin/game/tennis/${match.id}`} key={match.id}>
                                <Box className="sidebar-sublink" pl="56px" fontSize="12px">{match.eventName}</Box>
                              </Link>
                            ))}
                          </AccordionPanel>
                        </AccordionItem>
                      </Accordion>
                    ))}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>

            <Divider borderColor="rgba(255,255,255,0.1)" my={2} />

            <Link to="/admin/change-password">
              <Box className={`sidebar-link ${location.pathname === '/admin/change-password' ? 'active' : ''}`}>
                <i className="fas fa-key" />
                <span>Change Password</span>
              </Box>
            </Link>
            <Box
              className="sidebar-link"
              cursor="pointer"
              onClick={() => {
                dispatch({ type: "accountData/logOut", payload: {} });
                window.localStorage.clear();
                window.location.href = "/";
              }}
            >
              <i className="fas fa-sign-out-alt" style={{ color: '#ff6b6b' }} />
              <span style={{ color: '#ff6b6b' }}>Logout</span>
            </Box>
          </nav>
        </Box>

        {/* Main Content */}
        <Box className="main-content-area">
          {props.children}
        </Box>

        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          finalFocusRef={btnRef}
        >
          <DrawerOverlay />
          <DrawerContent bg="white">
            <DrawerCloseButton style={{ color: '#000' }} />
            <DrawerHeader style={{ color: '#000', borderBottom: '1px solid #eee' }}>Menu</DrawerHeader>
            <DrawerBody p={0} style={{ backgroundColor: '#fff' }} overflowY="auto">
              {/* Admin Menu */}
              <Box px={4} py={2}>
                <Link to="/admin" onClick={onClose}>
                  <Text color="black" fontWeight="600" py={2}>
                    <i className="fas fa-home" style={{ marginRight: '8px' }} />
                    Dashboard
                  </Text>
                </Link>
                <Link to="/admin/manage-client/list" onClick={onClose}>
                  <Text color="black" fontWeight="600" py={2}>
                    <i className="fas fa-users" style={{ marginRight: '8px' }} />
                    List of Clients
                  </Text>
                </Link>
              </Box>
              <Accordion allowMultiple allowToggle>
                <AccordionItem border="none">
                  <AccordionButton style={{ backgroundColor: '#f7f7f7', color: '#000' }}>
                    <Box as="span" flex="1" textAlign="left" fontWeight="600" style={{ color: '#000' }}>
                      <i className="fas fa-chess-queen" style={{ marginRight: '8px' }} />
                      Admin Masters
                    </Box>
                    <AccordionIcon style={{ color: '#000' }} />
                  </AccordionButton>
                  <AccordionPanel pb={2} bg="white">
                    <Link to="/admin/manage-client/list?filter=MASTER" onClick={onClose}>
                      <Text color="black" fontSize="14px" py={1} pl={2}>All Masters</Text>
                    </Link>
                    <Link to="/admin/manage-client/list?filter=CLIENT" onClick={onClose}>
                      <Text color="black" fontSize="14px" py={1} pl={2}>All Clients</Text>
                    </Link>
                    <Link to="/admin/manage-client/add" onClick={onClose}>
                      <Text color="black" fontSize="14px" py={1} pl={2}>Register New Client</Text>
                    </Link>
                  </AccordionPanel>
                </AccordionItem>
                {/* <AccordionItem border="none">
                  <AccordionButton style={{ backgroundColor: '#f7f7f7', color: '#000' }}>
                    <Box as="span" flex="1" textAlign="left" fontWeight="600" style={{ color: '#000' }}>
                      <i className="fas fa-credit-card" style={{ marginRight: '8px' }} />
                      Payment Solution
                    </Box>
                    <AccordionIcon style={{ color: '#000' }} />
                  </AccordionButton>
                  <AccordionPanel pb={2} bg="white">
                    <Link to="/admin/bank-details" onClick={onClose}>
                      <Text color="black" fontSize="14px" py={1} pl={2}>Bank Details</Text>
                    </Link>
                    <Link to="/admin/payment-snap" onClick={onClose}>
                      <Text color="black" fontSize="14px" py={1} pl={2}>Payment Snap</Text>
                    </Link>
                    <Link to="/admin/withdrawal-requests" onClick={onClose}>
                      <Text color="black" fontSize="14px" py={1} pl={2}>Withdrawal Requests</Text>
                    </Link>
                  </AccordionPanel>
                </AccordionItem> */}
                <AccordionItem border="none">
                  <AccordionButton style={{ backgroundColor: '#f7f7f7', color: '#000' }}>
                    <Box as="span" flex="1" textAlign="left" fontWeight="600" style={{ color: '#000' }}>
                      <i className="fas fa-file-alt" style={{ marginRight: '8px' }} />
                      Reports
                    </Box>
                    <AccordionIcon style={{ color: '#000' }} />
                  </AccordionButton>
                  <AccordionPanel pb={2} bg="white">
                    <Link to="/admin/reports/current-bet" onClick={onClose}><Text color="black" fontSize="14px" py={1} pl={2}>Current Bets</Text></Link>
                    <Link to="/admin/reports/account-statement" onClick={onClose}><Text color="black" fontSize="14px" py={1} pl={2}>Account Statement</Text></Link>
                    <Link to="/admin/reports/bet-history" onClick={onClose}><Text color="black" fontSize="14px" py={1} pl={2}>Bet History</Text></Link>
                    <Link to="/admin/reports/profit-loss" onClick={onClose}><Text color="black" fontSize="14px" py={1} pl={2}>User PnL</Text></Link>
                    <Link to="/admin/reports/casino-report" onClick={onClose}><Text color="black" fontSize="14px" py={1} pl={2}>Casino Report</Text></Link>
                    <Link to="/admin/market-analysis" onClick={onClose}><Text color="black" fontSize="14px" py={1} pl={2}>Market Analysis</Text></Link>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Box px={4} py={1}>
                <Link to="/admin/whatsapp-links" onClick={onClose}>
                  <Text color="black" fontWeight="600" py={2}>
                    <i className="fab fa-whatsapp" style={{ marginRight: '8px' }} />
                    WhatsApp Links
                  </Text>
                </Link>
              </Box>

              <Divider my={2} borderColor="#eee" />

              {/* Sports */}
              <Box px={4} py={1}>
                <Text color="#888" fontSize="12px" fontWeight="700" textTransform="uppercase" letterSpacing="1px">Sports</Text>
              </Box>
              <Accordion allowMultiple allowToggle>
                <AccordionItem border="none">
                  <AccordionButton style={{ backgroundColor: '#f7f7f7', color: '#000' }}>
                    <Box as="span" flex="1" textAlign="left" fontWeight="600" style={{ color: '#000' }}>
                      <i className="fas fa-futbol" style={{ marginRight: '8px' }} />
                      Football
                    </Box>
                    <AccordionIcon style={{ color: '#000' }} />
                  </AccordionButton>
                  <AccordionPanel style={{ backgroundColor: '#fff' }}>
                    {soccerMatchList &&
                      Object.keys(soccerMatchList).map((game) => (
                        <Accordion allowToggle allowMultiple key={game}>
                          <AccordionItem border="none">
                            <AccordionButton style={{ backgroundColor: '#fff', color: '#000' }}>
                              <Box as="span" flex="1" textAlign="left" style={{ color: '#000' }}>
                                {game}
                              </Box>
                              <AccordionIcon style={{ color: '#000' }} />
                            </AccordionButton>
                            <AccordionPanel style={{ backgroundColor: '#fff' }}>
                              {soccerMatchList[game].map((match) => (
                                <Link to={`/admin/game/soccer/${match.id}`} key={match.id} onClick={onClose}>
                                  <Text fontSize="14px" py={1} style={{ color: '#000' }}>
                                    {match.eventName}
                                  </Text>
                                </Link>
                              ))}
                            </AccordionPanel>
                          </AccordionItem>
                        </Accordion>
                      ))}
                  </AccordionPanel>
                </AccordionItem>
                <AccordionItem border="none">
                  <AccordionButton style={{ backgroundColor: '#f7f7f7', color: '#000' }}>
                    <Box as="span" flex="1" textAlign="left" fontWeight="600" style={{ color: '#000' }}>
                      <i className="fas fa-baseball-ball" style={{ marginRight: '8px' }} />
                      Cricket
                    </Box>
                    <AccordionIcon style={{ color: '#000' }} />
                  </AccordionButton>
                  <AccordionPanel style={{ backgroundColor: '#fff' }}>
                    {cricketMatchList &&
                      Object.keys(cricketMatchList).map((game) => (
                        <Accordion allowToggle allowMultiple key={game}>
                          <AccordionItem border="none">
                            <AccordionButton style={{ backgroundColor: '#fff', color: '#000' }}>
                              <Box as="span" flex="1" textAlign="left" style={{ color: '#000' }}>
                                {game}
                              </Box>
                              <AccordionIcon style={{ color: '#000' }} />
                            </AccordionButton>
                            <AccordionPanel style={{ backgroundColor: '#fff' }}>
                              {cricketMatchList[game].map((match) => (
                                <Link to={`/admin/game/cricket/${match.id}`} key={match.id} onClick={onClose}>
                                  <Text fontSize="14px" py={1} style={{ color: '#000' }}>
                                    {match.eventName}
                                  </Text>
                                </Link>
                              ))}
                            </AccordionPanel>
                          </AccordionItem>
                        </Accordion>
                      ))}
                  </AccordionPanel>
                </AccordionItem>
                <AccordionItem border="none">
                  <AccordionButton style={{ backgroundColor: '#f7f7f7', color: '#000' }}>
                    <Box as="span" flex="1" textAlign="left" fontWeight="600" style={{ color: '#000' }}>
                      <i className="fas fa-table-tennis" style={{ marginRight: '8px' }} />
                      Tennis
                    </Box>
                    <AccordionIcon style={{ color: '#000' }} />
                  </AccordionButton>
                  <AccordionPanel style={{ backgroundColor: '#fff' }}>
                    {tennisMatchList &&
                      Object.keys(tennisMatchList).map((game) => (
                        <Accordion allowToggle allowMultiple key={game}>
                          <AccordionItem border="none">
                            <AccordionButton style={{ backgroundColor: '#fff', color: '#000' }}>
                              <Box as="span" flex="1" textAlign="left" style={{ color: '#000' }}>
                                {game}
                              </Box>
                              <AccordionIcon style={{ color: '#000' }} />
                            </AccordionButton>
                            <AccordionPanel style={{ backgroundColor: '#fff' }}>
                              {tennisMatchList[game].map((match) => (
                                <Link to={`/admin/game/tennis/${match.id}`} key={match.id} onClick={onClose}>
                                  <Text fontSize="14px" py={1} style={{ color: '#000' }}>
                                    {match.eventName}
                                  </Text>
                                </Link>
                              ))}
                            </AccordionPanel>
                          </AccordionItem>
                        </Accordion>
                      ))}
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>

              <Divider my={2} borderColor="#eee" />

              <Box px={4} py={2}>
                <Link to="/admin/change-password" onClick={onClose}>
                  <Text color="black" fontWeight="600" py={2}>
                    <i className="fas fa-key" style={{ marginRight: '8px' }} />
                    Change Password
                  </Text>
                </Link>
                <Text
                  color="red.500"
                  fontWeight="600"
                  py={2}
                  cursor="pointer"
                  onClick={() => {
                    dispatch({ type: "accountData/logOut", payload: {} });
                    window.localStorage.clear();
                    window.location.href = "/";
                  }}
                >
                  <i className="fas fa-sign-out-alt" style={{ marginRight: '8px' }} />
                  Logout
                </Text>
              </Box>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Box>
    </>
  );
};

export default PrivateOutlet;
